import React from 'react';
import { Chip } from '@mui/material';
import { Flare, Thunderstorm, Cloud, RadioButtonChecked } from '@mui/icons-material';

const TYPE_CONFIG = {
  SOLAR_FLARE:       { label: 'Solar Flare',        color: '#ffa726', icon: <Flare sx={{ fontSize: 14 }} /> },
  GEOMAGNETIC_STORM: { label: 'Geomagnetic Storm',  color: '#7e57c2', icon: <Thunderstorm sx={{ fontSize: 14 }} /> },
  CME:               { label: 'CME',                color: '#26c6da', icon: <Cloud sx={{ fontSize: 14 }} /> },
  RADIATION_BELT:    { label: 'Radiation Belt',     color: '#ef5350', icon: <RadioButtonChecked sx={{ fontSize: 14 }} /> },
  SOLAR_ENERGETIC_PARTICLE: { label: 'SEP',         color: '#ab47bc', icon: <Flare sx={{ fontSize: 14 }} /> },
  INTERPLANETARY_SHOCK:     { label: 'IPS',         color: '#26a69a', icon: <Cloud sx={{ fontSize: 14 }} /> },
};

export default function EventTypeChip({ type, size = 'small' }) {
  const cfg = TYPE_CONFIG[type] || { label: type, color: '#78909c', icon: null };
  return (
    <Chip
      label={cfg.label}
      icon={cfg.icon}
      size={size}
      sx={{
        color: cfg.color,
        bgcolor: `${cfg.color}22`,
        border: `1px solid ${cfg.color}55`,
        fontWeight: 600,
        fontSize: 11,
        '& .MuiChip-icon': { color: `${cfg.color} !important` },
      }}
    />
  );
}
